import { atom } from 'jotai';

import { ToastProps } from '../components/cookbook/Toasts/Toast';

export const toastStateAtom = atom<ToastProps[]>([]);
